/**
 * Menu-permission route enforcement, bound to the live AppSidebar nav data.
 *
 * Binds `primaryMenuItems` + `standaloneNavItems` (the same source the sidebar
 * and the Menu Permissions dialog use) into the pure helpers in
 * `menuPermissions.core`. Used by AppShell to block ungranted sections by URL.
 */
import { primaryMenuItems, standaloneNavItems } from '@/components/layout/AppSidebar';
import {
  buildUrlIdEntries,
  resolveIdFromEntries,
  isRouteAllowed,
  firstGrantedPathFrom,
} from './menuPermissions.core';

// Built once from the sidebar's nav arrays — stays in sync automatically.
const ENTRIES = buildUrlIdEntries(standaloneNavItems as any, primaryMenuItems as any);

export function resolveMenuPermissionId(pathname: string): string | null {
  return resolveIdFromEntries(pathname, ENTRIES);
}

export function isMenuRouteAllowed(pathname: string, menuPermissions: string[]): boolean {
  return isRouteAllowed(pathname, ENTRIES, menuPermissions);
}

export function firstGrantedPath(menuPermissions: string[]): string {
  return firstGrantedPathFrom(primaryMenuItems as any, menuPermissions);
}
